<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id"> {{ props.label }}<span *ngIf="props.required && props.hideRequiredMarker !== true">*</span> </label>

  <div style="display: flex">
    <tui-textfield [tuiTextfieldCleaner]="false" tuiTextfieldSize="s" style="width: 100%; max-width: 300px">
      <label tuiLabel *ngIf="!formControl.value">Выберите дату</label>
      <input tuiInputDateTime [(ngModel)]="value" [formlyAttributes]="field" autocomplete="off" [disabled]="props.disabled"/>
      <tui-calendar *tuiTextfieldDropdown/>
    </tui-textfield>

    <button *ngIf="hasValue && !props.disabled" nbButton size="small" status="control" (click)="clear()" type="button">
      <nb-icon icon="close"/>
    </button>
  </div>

  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
